import { lazy } from 'react';
/** Открывает карточку блога */
export const BlogDetailsPageAsync = lazy(() => import('./BlogDetails/BlogDetailsPage'));